module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword"
    }
  }, [_vm._v("Foreword, by Dr. Mark Horton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Part1"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1"
    }
  }, [_vm._v("1. The Push for Colonization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The First Voyage: 1584")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Second Voyage: 1585–1586")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Resupply Mission: 1586")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The “Lost” Colony: 1587")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. John White’s Return Voyage: 1590")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Later Attempts: The Search (or Lack Thereof) for the Colonists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RCHAEOLOGY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Native Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Introduction to Archaeology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Real Search Begins: November 2009")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Daub Gone It: 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Mysterious Woman: 2011")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Guns and Brandy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Pay Dirt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Earth Listens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Survivors’ Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Theories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Algonquian Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0